import '../../../src/stylus/components/_grid.styl';
import Grid from './grid';
export default Grid('container');
//# sourceMappingURL=VContainer.js.map